module.exports = __webpack_public_path__ + "img/badge_7.892af641.png";